import createIcon from '../../createIcon';

/**
 * @component @name AddHomeWork
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMTAuNjhWMTBMOCA1TDEgMTBWMjBINlYxNEgxMFYyMEgxMS42OEMxMS4yNSAxOS4wOSAxMSAxOC4wOCAxMSAxN0MxMSAxNC4yMSAxMi42NCAxMS44MSAxNSAxMC42OFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMyAxMi4xMVYySDEwVjMuOTdMMTcgOC45N1YxMC4wOEMxNy4zMyAxMC4wMyAxNy42NiAxMCAxOCAxMEMxOS45NiAxMCAyMS43MyAxMC44MSAyMyAxMi4xMVpNMTcgNkgxOVY4SDE3VjZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjMgMTdDMjMgMTQuMjQgMjAuNzYgMTIgMTggMTJDMTUuMjQgMTIgMTMgMTQuMjQgMTMgMTdDMTMgMTkuNzYgMTUuMjQgMjIgMTggMjJDMjAuNzYgMjIgMjMgMTkuNzYgMjMgMTdaTTE3LjUgMjBWMTcuNUgxNVYxNi41SDE3LjVWMTRIMTguNVYxNi41SDIxVjE3LjVIMTguNVYyMEgxNy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddHomeWork = createIcon('AddHomeWork', [
  [
    'path',
    {
      d: 'M15 10.68V10L8 5L1 10V20H6V14H10V20H11.68C11.25 19.09 11 18.08 11 17C11 14.21 12.64 11.81 15 10.68Z',
      key: 'rz60vu',
    },
  ],
  [
    'path',
    {
      d: 'M23 12.11V2H10V3.97L17 8.97V10.08C17.33 10.03 17.66 10 18 10C19.96 10 21.73 10.81 23 12.11ZM17 6H19V8H17V6Z',
      key: '1lcnw8',
    },
  ],
  [
    'path',
    {
      d: 'M23 17C23 14.24 20.76 12 18 12C15.24 12 13 14.24 13 17C13 19.76 15.24 22 18 22C20.76 22 23 19.76 23 17ZM17.5 20V17.5H15V16.5H17.5V14H18.5V16.5H21V17.5H18.5V20H17.5Z',
      key: '1nv1sv',
    },
  ],
]);

export default AddHomeWork;
